import { RequestManager } from "./index";

// Outside production (local/staging) some legacy data is served from the disbursement dev-box behind the
// versioned base; production keeps the default base. Same RequestManager class as the default `request`,
// so interceptors/response handling are identical — only the base URL differs.
const baseUrl = "https://disbursement-dev-box.flip.id/big_web_api/v1";

const request = new RequestManager(baseUrl);

export default request;
